import { useState } from "react";

import { useEditDiscountMutation } from "@modules/discounts/services/mutations";
import { ActiveDiscountSwitchProps } from "./types";

export function useActiveDiscountSwitch({ id, value }: ActiveDiscountSwitchProps) {
  const [isActive, setIsActive] = useState(value);

  const { mutateAsync, isPending } = useEditDiscountMutation(id);

  const toggle = async () => {
    await mutateAsync({
      active: !isActive,
    });

    setIsActive((prev) => !prev);
  }

  return { isActive, isPending, toggle };
}
